module.exports = __webpack_public_path__ + "static/OutsideBreaker-7309a72ac4cd049a5cb3f47d2645e665.png";